"use client";

import { ActivityDisplayPreview } from "./previews";

type GolfDisplayProps = {
  data: Record<string, unknown> | null;
  participants: {
    id: string;
    displayName: string;
    avatarUrl: string | null;
    username: string | null;
  }[];
};

export function GolfDisplay({ data, participants }: GolfDisplayProps) {
  return (
    <ActivityDisplayPreview
      activityId="golf"
      data={data}
      participants={participants}
    />
  );
}
